import { gql } from '../../__generated__/gql'

export const CURRENT_USER_QUERY = gql(`
  query currentUser {
    currentUser {
      ...userProfileFields
    }
  }
`)
